import React from "react";
import { cn } from "./ui/utils";

interface PageShellProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  noBottomPad?: boolean;
}

export function PageShell({ children, className, noPadding, noBottomPad }: PageShellProps) {
  return (
    <div
      className={cn(
        // min-h-full (not min-h-screen): 100vh under iOS MAX keyboard creates a white gap
        "min-h-full relative",
        !noPadding && "px-4",
        !noBottomPad &&
          "pb-[calc(7rem+env(safe-area-inset-bottom,0px)+var(--sab-fallback,0px))]",
        className
      )}
    >
      {children}
    </div>
  );
}
